import { Component, Input } from '@angular/core';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CreateEditWindowComponent } from './create-edit-window.component';
import { IntlService } from '@progress/kendo-angular-intl';
import { User } from '@app/core/models';


@Component({
  selector: 'edit-user-password',
  template: `
  <div class="k-overlay" *ngIf="opened"></div>
  <kendo-window [width]="400" title="Cambiar contraseña" *ngIf="opened" (close)="onClose()">
    <form novalidate [formGroup]="form">
      <div class="example-wrapper form-detail">        
          <div class="row">              
              <div class="col-xs-12 col-sm-12 example-col">
                  <kendo-label text="Contraseña:"></kendo-label>
                  <kendo-textbox-container>
                    <input type="password" formControlName="pass1" class="k-textbox" controlTrim/>
                  </kendo-textbox-container>
                  <div *ngIf="f.pass1.invalid && (f.pass1.dirty || f.pass1.touched)">                  
                    <div *ngIf="f.pass1.errors">
                      <kendo-formerror *ngIf="f.pass1.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                      <kendo-formerror *ngIf="f.pass1.errors.minlength">
                        Error: Debe contener al menos 4 caracteres.
                      </kendo-formerror>
                    </div>  
                  </div>                
              </div>
              <div class="col-xs-12 col-sm-12 example-col">
                  <kendo-label text="Confirmar Contraseña:"></kendo-label>
                  <kendo-textbox-container>
                    <input type="password" formControlName="pass2" class="k-textbox" controlTrim/>
                  </kendo-textbox-container>
                  <div *ngIf="f.pass2.invalid && (f.pass2.dirty || f.pass2.touched)">                  
                    <div *ngIf="f.pass2.errors">
                      <kendo-formerror *ngIf="f.pass2.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                      <kendo-formerror *ngIf="f.pass2.errors.minlength">
                        Error: Debe contener al menos 4 caracteres.
                      </kendo-formerror>
                    </div>                       
                  </div>
                  <!--<div *ngIf="!(f.pass1.errors && f.pass2.errors)">
                    <kendo-formerror *ngIf="f.pass1.value != f.pass2.value">
                      Error: No coinciden las contraseñas.
                    </kendo-formerror>
                  </div>-->              
              </div>
          </div>
      </div>
    </form> 

    <div class="text-right">
        <button type="button" class="k-button" (click)="onCancel()">Cancelar</button>
        <button type="button" class="k-button k-primary ml-1" (click)="onSave()" [disabled]='!form.valid'>Guardar</button>
    </div>
       
  </kendo-window>      
  `,
  styles: [`
    .k-textbox-container, input.k-textbox {
      width: 100%;
    }
  `],
  providers: [ DatasourceService ]
})
export class EditUserPasswordComponent extends CreateEditWindowComponent {

  @Input() table: string = 'users';

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService, protected intl: IntlService) {

    super(authService, service, alertService);

  }

  //@Override
  protected getFormGroup(user: User, dataItem?: any): FormGroup {

    return new FormGroup({
      'id': new FormControl((user == null) ? 0: user.id),  
      'pass1': new FormControl("", [Validators.required, Validators.minLength(4)]),
      'pass2': new FormControl("", [Validators.required, Validators.minLength(4)])
    });

  };

  //@Override
  protected getData(formGroup: FormGroup): Object {

    return Object.assign({}, formGroup.value, { 
      password: formGroup.value.pass1
    });

  }; 

  //@Override
  public edit(dataItem: any, rowIndex: number = null): void {

    this.mode = 'EDIT';
    this.opened = true;
    this.form = this.getFormGroup(this.currentUser, {})
  
  }  

  //@Override
  public onSave(): void {
    
    let data : any = this.getData(this.form);
    console.log('data', data)  
    
    if (data.pass1 != data.pass2){
							
      this.alertService.showError('No coinciden las contraseñas.');
      return;
      
    }
    
    this.service.updateRow(this.table, data) 
      .subscribe(
        (res) => {
          console.log("POST Request is successful: ", this.table, data);
          console.log("mode = " + this.mode);

          this.save.emit({mode: this.mode, dataItem: res.data[0]});
          this.opened = false;
        },
        (fail) => {        
          console.log("Error", fail);
          // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      ); 

  }

}
